import React, { useEffect, useState } from 'react';
import { mockData } from '../mock';
import HeroSection from '../components/HeroSection';
import CapabilitiesSection from '../components/CapabilitiesSection';
import ShowcaseSection from '../components/ShowcaseSection';
import ProcessSection from '../components/ProcessSection';
import TechnologiesSection from '../components/TechnologiesSection';
import CTASection from '../components/CTASection';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Home = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="overflow-hidden">
        <HeroSection data={mockData.hero} stats={mockData.stats} />
        <CapabilitiesSection capabilities={mockData.capabilities} />
        <ShowcaseSection />
        <ProcessSection process={mockData.process} />
        <TechnologiesSection technologies={mockData.technologies} />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
